<template>
  <div>
    <van-popup
      v-model="isShow"
      position="right"
      lock-scroll
      close-on-popstate
      :style="{ height: '100%', width:'100%' }"
    >
      <ld-header
        @click-left="isShow = false"
        @click-right="complie"
      >
        <span
          slot="right"
          class="main-color"
        >
          {{ $t('B010','保存') }}
        </span>
      
        编辑个人信息
      </ld-header>
    
      <van-cell-group>
        <van-cell>
          <h4 slot="title">
            {{ $t('Fill','填写个人偏好') }} <span class="gray font12">(字数不超过100字)</span>
          </h4>
        </van-cell>
        <van-field
          v-model="preference"
          rows="5"
          autosize
          type="textarea"
          maxlength="100"
          placeholder="请输入您的喜好！"
          show-word-limit
        />
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'EditPreference',
  mixins: [mixin],
  data() {
    return {
      preference: ''
    }
  },
  created () {
    this.preference = this.empInfo.preference
  },
  methods: {
    complie () {
      this.empInfo.preference = this.preference
      this.save()
    }
  }
}
</script>